export const priceComponent = {
  priceComponent: {
    fontSize: "x-large",
    smallscreen: {
      fontSize: "x-large",
    },
  },
};
